import { useRealtimeChannel } from '@/hooks/useRealtimeChannel'
import { fetchModerationBadge } from '@/lib/p0'
import { queryClient } from '@/lib/query'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

export interface SidebarBadges {
  'moderation.pending': number
  'payouts.pending': number
  'scrapers.failed': number
  'bots.active': number
  'agents.running': number
  'system.failed': number
}

/** Live sidebar badge values. Phase 4 wires moderation queue; later phases add the rest. */
export function useSidebarBadges(): Partial<SidebarBadges> {
  const moderation = useQuery({
    queryKey: ['sidebar-badge-moderation'],
    queryFn: fetchModerationBadge,
    refetchInterval: 60_000,
    staleTime: 30_000
  })

  // Real-time bump on new reports
  useRealtimeChannel('admin.moderation.queue', () => {
    queryClient.invalidateQueries({ queryKey: ['sidebar-badge-moderation'] })
  })
  useRealtimeChannel('admin.activity', (event) => {
    const e = event as { kind?: string }
    if (e.kind === 'moderation') {
      queryClient.invalidateQueries({ queryKey: ['sidebar-badge-moderation'] })
    }
  })

  // Suppress unused warning — when other badges land, they wire through here
  useEffect(() => {}, [])

  return {
    'moderation.pending': moderation.data?.pending ?? 0
  }
}
